const createBrandBreadcrumb = (brandName, categoryType = 'Eyeglasses') => [
  {
    label: 'HomePage',
    link: 'https://www.owndays.com/sg/en/',
  },
  {
    label: categoryType,
    link: categoryType.toLowerCase(),
  },
  {
    label: 'Brands',
    link: `brands`,
  },
  {
    label: brandName,
  },
];

const createDefaultBreadcrumb = (categoryType = 'Eyeglasses') => [
  {
    label: 'HomePage',
    link: 'https://www.owndays.com/sg/en/',
  },
  {
    label: categoryType,
    link: categoryType.toLowerCase(),
  },
  {
    label: 'Brands',
    link: `brands`,
  },
];

const getBrandBreadcrumb = (brand, categoryType) => {
  const brandMap = {
    air: 'AIR',
    essential: 'OWNDAYS | ESSENTIAL',
    sun: 'OWNDAYS | SUN',
    graphbelle: 'Graph Belle',
    JohnDillinger: 'John Dillinger',
    Senichisaku: 'Senichisaku',
    niche: 'NICHE',
    Junni: 'Junni',
    kmoriyama: 'K.moriyama',
    zeon: 'ZEON EXCLUSIVE EYEGLASSES & SUNGLASSES',
    'harry-potter': 'Harry Potter × OWNDAYS',
    owndayspc: 'OWNDAYS PC',
  };

  if (brand === 'default') {
    return createDefaultBreadcrumb(categoryType);
  }

  return brandMap[brand]
    ? createBrandBreadcrumb(brandMap[brand], categoryType)
    : createDefaultBreadcrumb(categoryType);
};

export default getBrandBreadcrumb;
